"use strict";

jQuery(document).ready(function ($) {
  $.extend($.expr[':'], {
    emptyOrWhitespace: function emptyOrWhitespace(el) {
      return !$.trim($(el).html());
    }
  });
  $('.filters__filter input[type=checkbox]').on('click', function () {
    $('#searchPagedVariable').val(1);
    performSearch();
  });
  $('.filters__filter input[type=radio]').on('click', function () {
    var filterList = $('.filters--active');
    filterList.find('[data-group=' + $(this).data('group') + ']').not('[data-filter=' + $(this).data('filter') + ']').remove();
    $('#searchPagedVariable').val(1);
    performSearch();
  });
  $('#dd_sort_by').on('change', function () {
    $('#searchSortByVariable').val($(this).val());
    performSearch();
  });

  //  Handle pagination clicks
  $('#searchPagination').on('click', '.page-numbers', function (e) {
    e.preventDefault();
    var page = $(this).data('page');
    $('#searchPagedVariable').val(page);
    var targetElement = $('.search-results__pages')[0]; // Convert the target to a DOM element

    // Scroll to the target element using scrollIntoView
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        // Use smooth scrolling
        block: 'start' // Align the top of the target element with the top of the viewport
      });
    }

    performSearch();
  });

  // filters
  $('.filters__filter--options').on('change', 'input', function () {
    var clicked = $(this);
    var siblings = clicked.closest('li').siblings();
    var filterList = $('.filters--active');

    // check if it has been selected a distance option
    if ($(this).closest('.filters__filter--options').hasClass('cg_distance_filter')) {
      // check if the user has given permission to be tracked

      // if ("geolocation" in navigator) {
      //     /* geolocation is available */
      //     navigator.geolocation.getCurrentPosition((position) => {
      //         document.cookie = "latitude=" + position.coords.latitude;
      //         document.cookie = "longitude=" + position.coords.longitude;
      //
      //         // update input filters
      //         $('#user_lat').val(position.coords.latitude);
      //         $('#user_lon').val(position.coords.longitude);
      //     });
      //
      // } else {
      //     /* geolocation IS NOT available */
      // }
    }
    if (clicked.is(':checked')) {
      var newFilter = $("<span></span>").addClass('filter').attr('data-group', clicked.data('group')).attr('data-filter', clicked.data('filter')).text(clicked.data('name'));
      if (clicked.data('override') === 'all') {
        siblings.find('[data-group=' + clicked.data('group') + ']').prop('checked', false);
        filterList.find('[data-group=' + clicked.data('group') + ']').remove();
      } else {
        var overrideOption = siblings.find('[data-override=all');
        if (overrideOption) {
          overrideOption.prop('checked', false);
          filterList.find('[data-filter=' + overrideOption.data('filter') + ']').remove();
        }
      }
      filterList.append(newFilter);
    } else {
      filterList.find('[data-filter=' + clicked.data('filter') + ']').remove();
    }
    setClearAll();
  });
  $('.filters__filter--options').on('change', 'select', function () {
    var clicked = $(this).find('option:selected');
    var filterList = $('.filters--active');
    filterList.find('[data-group=' + clicked.data('group') + ']').remove();
    if (clicked.val() !== "0") {
      var newFilter = $("<span></span>").addClass('filter').attr('data-group', clicked.data('group')).attr('data-filter', clicked.data('filter')).text(clicked.data('name'));
      filterList.append(newFilter);
    }
    setClearAll();
    performSearch();
  });
  $('.filters--active').on('click', '.filter', function () {
    var clicked = $(this);
    clicked.remove();
    $('.filters__filter--options [data-filter="' + clicked.data('filter') + '"]').prop('checked', false);
    if ($('form#filters input[name="' + clicked.data('group') + '"]').length > 0 && clicked.data('group') != 'radius' && clicked.data('group') != 'byDate') {
      $('form#filters input[name="' + clicked.data('group') + '"]').val("");
    }
    if ($('form#filters select option[data-group="' + clicked.data('group') + '"]').length > 0 && clicked.data('group') == 'byDate') {
      // Remove the selected attribute from all selected options
      $('form#filters select option[data-group="' + clicked.data('group') + '"]').prop('selected', false);
    }
    setClearAll();
    performSearch();
  });
  $('.filters--clear').on('click', '.clear-all-filters', function (e) {
    e.preventDefault();
    $('.filters--active .filter').remove();
    $('.filters__filter--options input').prop('checked', false);
    $('.filters__filter--options select').find('option').prop('selected', false);
    setClearAll();
  });
  function setClearAll() {
    var filterList = $('.filters--active');
    var clearAll = $('.clear-all-filters');
    if (filterList.length && filterList.is(':emptyOrWhitespace')) {
      clearAll.removeClass('active');
    } else {
      clearAll.addClass('active');
    }
  }
  function clearAllInputs() {
    $('#filters').find('input[type="checkbox"]:not([name="tax_post_type[]"])').prop('checked', false);
    $('#filters input[type=radio]').prop('checked', false);
    $('#filters select').prop('selected', false);
    $('#date_m_y option:eq(0)').prop('selected', true);
  }
  $('.clear-all-filters').on('click', function () {
    setClearAll();
    clearAllInputs();
    performSearch();
  });

  // let trigger the event for the checked elements
  $('#filters input[type=checkbox]:checked').trigger('change');
  $('#filters input[type=radio]:checked').trigger('change');
  setClearAll();

  // Variable to store the current AJAX request object
  var currentAjaxRequest;
  function performSearch() {
    setClearAll();

    // Clear the previous formData
    var formData = '';

    // Add a delay before serializing the form
    setTimeout(function () {
      // Abort the previous AJAX request if it exists and is still in progress
      if (currentAjaxRequest && currentAjaxRequest.readyState !== 4) {
        currentAjaxRequest.abort();
      }
      var formData = jQuery('#filters').serialize();
      //var jsonData = JSON.stringify(formData);
      var ajaxurl = ajax.ajax_url; // Use WordPress ajax_url

      // Store the new AJAX request object
      currentAjaxRequest = jQuery.ajax({
        type: 'POST',
        url: ajaxurl,
        dataType: "json",
        encode: true,
        data: {
          'action': 'custom_post_search',
          'formData': formData
        },
        beforeSend: function beforeSend() {
          jQuery('#searchResults').addClass('loading-effect');
        },
        complete: function complete() {
          jQuery('#searchResults').removeClass('loading-effect');
        },
        success: function success(response) {
          jQuery('#current_page').html(response.current_page);
          jQuery('#max_num_pages').html(response.max_num_pages);
          jQuery('#searchResults').empty().html(response.result);
          jQuery('#searchPagination').html(response.pagination);
        },
        error: function error(response) {
          jQuery('#searchResults').html(response.result);
        }
      });
    }, 100); // Delay before serializing the form
  }
});